/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { combineReducers } from "redux";
import { authCustomerReducer } from "cms/store/reducers/auth-customer";
import { orgSettingsReducer } from "cms/store/reducers/orgSettings";
import { webpageReducer } from "cms/store/reducers/webpage";
import { websiteReducer } from "cms/store/reducers/website";

const reducers = combineReducers({
    authCustomer: authCustomerReducer,
    orgSettings: orgSettingsReducer,
    webpage: webpageReducer,
    website: websiteReducer,
});

export default reducers;
